export const t = (key, options) => I18n.t(`project_hours_tracking.${key}`, options)

const locale = () => I18n.locale || "fr"

export const hours = (value, { signed = false } = {}) => {
  if (value === null || value === undefined) return "–"
  const number = Math.round(Number(value) * 10) / 10
  const text = Math.abs(number).toLocaleString(locale(), { maximumFractionDigits: 1 })
  const sign = signed && number !== 0 ? (number > 0 ? "+" : "−") : number < 0 ? "−" : ""
  return `${sign}${text} h`
}

export const money = (cents, currency, { signed = false } = {}) => {
  if (cents === null || cents === undefined) return "–"
  const value = Math.round(Number(cents) / 100)
  const text = Math.abs(value).toLocaleString(locale(), { style: "currency", currency: currency || "EUR", maximumFractionDigits: 0 })
  const sign = signed && value !== 0 ? (value > 0 ? "+" : "−") : value < 0 ? "−" : ""
  return `${sign}${text}`
}

export const percent = value => (value === null || value === undefined ? "–" : `${Math.round(value)} %`)

export const shortDate = iso => {
  if (!iso) return ""
  return new Date(`${iso}T00:00:00`).toLocaleDateString(locale(), { day: "numeric", month: "short" })
}

export const FLAG_TONES = {
  risk:  { dot: "bg-rose-500",    text: "text-rose-700",    soft: "bg-rose-50 ring-rose-200" },
  watch: { dot: "bg-amber-400",   text: "text-amber-700",   soft: "bg-amber-50 ring-amber-200" },
  ok:    { dot: "bg-emerald-500", text: "text-emerald-700", soft: "bg-emerald-50 ring-emerald-200" },
  idle:  { dot: "bg-slate-300",   text: "text-slate-500",   soft: "bg-slate-50 ring-slate-200" },
}

export const varianceTone = (variance, sold) => {
  if (!sold || variance <= 0) return "text-emerald-700"
  return variance > sold * 0.1 ? "text-rose-700" : "text-amber-700"
}

export const performanceTone = value => {
  if (value === null || value === undefined) return "text-slate-400"
  if (value >= 1) return "text-emerald-700"
  return value >= 0.9 ? "text-amber-700" : "text-rose-700"
}
